import { Carousel as Slider, Tag } from 'antd'
import Flex from 'components/Flex'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

export const Sliders = styled(Slider)`
  .ant-carousel .slick-slide {
    text-align: center;
    line-height: 19px;
    background: ${COLORS.WHITE};
    overflow: hidden;
  }

  .ant-carousel .slick-slide div {
    color: ${COLORS.GREY_T_20};
  }
`
export const CarouselFlex = styled(Flex)`
  gap: 20px;
`

export const HeaderFlex = styled(Flex)`
  gap: 10px;
  margin: 0 0 15px 40px;
  width: 100%;
`

export const IntervierFlex = styled(Flex)`
  gap: 5px;

  height: 45px;
  background: ${COLORS.BLUE_T_97};
  padding: 10px;
  border: 1px solid ${COLORS.BLUE_T_80};
  border-radius: 10px;
  cursor: pointer;
`
export const InterviewerName = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_20};
`
export const GroupFlex = styled(Flex)`
  gap: 35px;
  margin: 25px 0;
`
export const TimeDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${props => (props.font ? props.font : `${FONT.F_XS}`)};
  line-height: 15px;
  color: ${COLORS.GREY_T_60};
  white-space: nowrap;
`
export const GroupIdDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_XS};
  line-height: 18px;
  color: ${COLORS.GREY_T_30};
  margin-bottom: 3px;
`
export const InterviewFlex = styled(Flex)`
  gap: 10px;
  width: 100%;
`
export const InterviewInfoFlex = styled(Flex)`
  padding: 20px 15px;
  border: 1px solid ${COLORS.GREY_T_90};
  width: 100%;
  border-radius: 10px;
`
export const AdjustIcon = styled.div`
  height: 50px;
  text-align: center;
  position: relative;
  background-color: ${COLORS.WHITE};
  padding: 18px;
  cursor: pointer;
  left: -2px;
`
export const RightArrowDiv = styled.div`
  height: 50px;
  min-width: 68px;
  text-align: center;
  position: relative;
  left: -26%;
  background-color: ${COLORS.WHITE};
  padding: 18px;
  cursor: pointer;
  z-index: '10';
`

export const CaroselDiv = styled.div`
  position: relative;
  width: 100%;
  left: -2%;
`
export const FooterFlex = styled(Flex)`
  gap: 10px;
`

export const BreakWrapper = styled(Flex)`
  gap: 10px;
  background: #fefbf8;
  border: 1px solid #fdede2;
  border-radius: 10px;
  height: 54px;
  padding-left: 10px;
  margin-bottom: 10px;
`

export const BreakText = styled(Flex)`
  font-weight: 600;
  font-size: 14px;
  color: #343e59;
`
export const TagWarapper = styled(Tag)`
  background: #ebecee;
  border-radius: 6px;
  align-items: center;
  padding: 3px 8px;
  font-weight: 500;
  font-size: 14px;
  color: #010e30;
`

export const TimeFlex = styled(Flex)`
  gap: 5px;
`
